import * as React from 'react';
import { FC } from 'react';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';

import { ContentContainer, ModalBody, ModalHeading } from './styled';
import { IAdsPersonalizationDeniedModalViewProps } from './types';

export const AdsPersonalizationDeniedModalView: FC<React.PropsWithChildren<
  IAdsPersonalizationDeniedModalViewProps
>> = ({
  isOpen,
  dismissModal,
  openSettings,
  modalBodyText,
  modalHeadingText,
  openSettingsButtonText,
}) => {
  return (
    <Dialog
      showDialog={isOpen}
      testID="ads-personalization-denied-modal"
      headingComponent={
        <ModalHeading testID="ads-personalization-denied-heading">{modalHeadingText}</ModalHeading>
      }
      bodyComponent={
        <ContentContainer testID="ads-personalization-denied-body">
          <ModalBody>{modalBodyText}</ModalBody>
        </ContentContainer>
      }
      actions={
        <ActionButton
          fullWidth
          testID="ads-personalization-denied-open-settings"
          onPress={openSettings}
        >
          {openSettingsButtonText}
        </ActionButton>
      }
      modalAppearanceEventMessage="Previously Denied App Tracking Transparency Modal"
      showCloseButton
      onDismiss={dismissModal}
    />
  );
};
